import {SessionTimeState} from './session-time.reducer.types';
import {START} from '../constants/app-state.constants';

export const defaultSessionTimeCacheEntry = {
	previousStartTimestamp: null,
	startTimestamp: null
};

const initialState: SessionTimeState = {
	cache: {}
};

export const sessionTimeReducer = (previousState = initialState, action): SessionTimeState => {
	switch (action && action.type) {
		case START:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.currentAppId]: {
						previousStartTimestamp: previousState.cache[action.currentAppId]?.startTimestamp,
						startTimestamp: action.timestamp
					}
				}
			};
			break;

		default:
			return previousState;
	}
};
